import { api } from '../utils/api'
import type {
  GetCustomerSpendingLimitResponse,
  GetKlantLocatiesResponse,
} from '../types/api'

export const getCustomerLocations = async (customerNumber: string | number) => {
  const response = await api.get<GetKlantLocatiesResponse>(
    `/Klant/${customerNumber}/Locaties`
  )
  return response.data
}

export const getCustomerSpendingLimit = async (
  customerNumber: string | number,
  language: string,
  warningPercentage?: number
) => {
  const response = await api.get<GetCustomerSpendingLimitResponse>(
    `/Klant/${customerNumber}/SpendingLimit?language=${language}${warningPercentage ? `&warningPercentage=${warningPercentage}` : ''}`
  )
  return response.data
}
